import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  styled,
  Box,
  Grid,
  Autocomplete,
  TextField,
  IconButton,
  Button,
  Typography,
} from "@mui/material";
import Modal from "@mui/material/Modal";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import CloseIcon from "@mui/icons-material/Close";

import { companyWiseEmp } from "../../actions/Companywiseclient";
import { CustomInputField } from "../CommonComponents/CustomCompontes";

const ModalHeader = styled("div")({
  fontSize: "20px",
  fontWeight: "700",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  position: "sticky",
  top: 0,
  background: "#fff",
  zIndex: 9,
  paddingTop: "10px",
  borderBottomLe: "1px slid red",
});

const ModalBody = styled("div")({
  padding: "15px",
});

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  maxWidth: "900px",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "10px",
  // overflow: "hidden",
  // height: "50vh",
  overflow: "auto",
  padding: 3,
};

const DefaultMeetingConfiguration = ({ companyId, siteId }) => {
  const [open, setOpen] = React.useState(false);
  const [searchUser, setSearchUser] = React.useState("");
  const [userList, setUserList] = React.useState([]);
  const [selectedUser, setSelectedUser] = React.useState([]);
  const [userInputVal, setUserInputVal] = React.useState("");
  const [meetingDistance, setMeetingDistance] = React.useState("0");
  const userListToSelect = userList.filter(
    (user) => user.isAutoCreateMeetingOnDashBoardEnabled !== true
  );

  const fetchUsersListBySelectedCompany = async () => {
    const res = await companyWiseEmp.getUserListByCompanyIdForDefaultMeeting({
      // companyId: selectedCompany.id,
      companyId: companyId,
      siteId: siteId?.id || null,
    });
    if (res !== null && res.data && Boolean(res.data.length)) {
      setUserList(res.data);
      setMeetingDistance(res.data[0]?.defaultMeetingDistance);
    } else {
      setUserList([]);
    }
  };

  const handleSaveDefaultMeetingForUser = async () => {
    if (!Boolean(selectedUser.length)) {
      return alert("Please select user.");
    }
    const response = await companyWiseEmp.saveDefaultMeetingPermissionUserWise({
      userIds: selectedUser.map((user) => user.id),
      value: true,
    });
    if (response !== null) {
      alert(response.responseDescription);
      fetchUsersListBySelectedCompany();
      setSelectedUser([]);
      setUserInputVal("");
    } else {
      alert("Something Went Wrong.");
    }
  };

  const handleRemoveDefaultMeetingPermission = async (user) => {
    const response = await companyWiseEmp.saveDefaultMeetingPermissionUserWise({
      userIds: [user.id],
      value: false,
    });
    if (response !== null) {
      fetchUsersListBySelectedCompany();
      alert(response.responseDescription);
    } else {
      alert("Something Went Wrong.");
    }
  };

  const handleSaveDistance = async () => {
    if (!Boolean(meetingDistance)) {
      setMeetingDistance(userList[0]?.defaultMeetingDistance || "");
      return alert("Meeting distance is required.");
    }
    const response = await companyWiseEmp.saveDefaultMeetingPermissionUserWise({
      // userIds: selectedUser.map((user) => user.id),
      value: true,
      companyId: companyId,
      defaultMeetingDistance: meetingDistance,
    });
    if (response !== null) {
      alert(response.responseDescription);
      fetchUsersListBySelectedCompany();
    } else {
      alert("Something Went Wrong.");
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const userListToRender = userList.filter(
    (user) => user.isAutoCreateMeetingOnDashBoardEnabled === true
  );

  React.useEffect(() => {
    fetchUsersListBySelectedCompany();
  }, [companyId, siteId]);

  return (
    <div>
      {/* <Grid className="CompanyBox"> */}
      <Accordion className="main_accoardian" defaultExpanded={true}>
        <AccordionSummary
          className="accordianHeader"
          expandIcon={
            <AddCircleIcon fontSize="large" style={{ color: "white" }} />
          }
          aria-controls="panel1a-content"
          style={{
            background: "rgb(10 166 141)",
            borderRadius: "10px 10px 0px 0px",
            overflow: "hidden",
          }}
        >
          <Grid>
            <Grid>
              <h3
                style={{
                  color: "#fff",
                  marginLeft: "10px",
                  padding: "10px 2px",
                }}
              >
                Auto Default Meeting Configuration:-
              </h3>
            </Grid>
          </Grid>
        </AccordionSummary>
        <AccordionDetails>
          <Box sx={{ my: 1 }}>
            <Grid container spacing={3}>
              <Grid item>
                <CustomInputField
                  sx={{
                    // width: "100%",
                    width: "300px",
                    margin: "0px !important",
                    // ".css-1y3xnst-MuiFormControl-root-MuiTextField-root input ":
                    //   {
                    //     paddingTop: "20px !important",

                    //     paddingBottom: "20px !important",
                    //   },
                  }}
                  required
                  id="outlined-basic"
                  label="Meeting Distance(in Meter)"
                  name="meetingDistance"
                  variant="outlined"
                  size="small"
                  inputProps={{
                    maxLength: 10,
                    style: { padding: "15px 15px" },
                  }}
                  value={meetingDistance}
                  onChange={(e) =>
                    setMeetingDistance(
                      e.target.value.replace(/\D/g, "").replace(/^0/, "")
                    )
                  }
                />
              </Grid>
              <Grid item>
                <div
                  className="field_box"
                  style={{
                    paddingBottom: "12px",
                  }}
                >
                  <div
                    className="field_box_btn1"
                    style={{
                      cursor: "pointer",
                    }}
                    onClick={handleSaveDistance}
                  >
                    Save distance
                  </div>
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid item>
                <div className="field_box">
                  <Autocomplete
                    size="small"
                    multiple
                    className="select_box_forCompanyWise"
                    limitTags={1}
                    id="multiple-limit-tags-userlist"
                    options={
                      userListToSelect.length
                        ? [{ id: 0, name: "Select All" }, ...userListToSelect]
                        : []
                    }
                    getOptionLabel={(option) =>
                      option.id === 0
                        ? `${option.name}`
                        : `${option.name}(${option.empCode})`
                    }
                    disablePortal={true}
                    fullWidth
                    value={selectedUser}
                    onChange={(event, newValue) => {
                      if (
                        newValue[newValue.length - 1] &&
                        newValue[newValue.length - 1].id === 0
                      ) {
                        setSelectedUser(
                          userList.filter(
                            (user) =>
                              user.isAutoCreateMeetingOnDashBoardEnabled !==
                              true
                          )
                        );
                      } else {
                        setSelectedUser(newValue);
                      }
                    }}
                    inputValue={userInputVal}
                    onInputChange={(event, newVal) => {
                      setUserInputVal(newVal);
                    }}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        margin="dense"
                        placeholder={
                          Boolean(userListToSelect?.length) &&
                          Boolean(
                            userListToSelect?.length === selectedUser?.length
                          )
                            ? ""
                            : "Select User"
                        }
                      />
                    )}
                  />
                </div>
              </Grid>
              <Grid item>
                <div
                  className="field_box"
                  style={{
                    // backgroundColor: "orange",
                    paddingBottom: "12px",
                  }}
                >
                  <div
                    className="field_box_btn1"
                    style={{
                      cursor: "pointer",
                      paddingLeft: "35px",
                      paddingRight: "35px",
                    }}
                    onClick={handleSaveDefaultMeetingForUser}
                  >
                    Add
                  </div>
                </div>
              </Grid>
            </Grid>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 2,
                my: 1,
              }}
            >
              {userListToRender.slice(0, 5).map((user) => {
                return (
                  <Box
                    // key={item.id}
                    key={user.id}
                    sx={{
                      backgroundColor: "#E0DCD6",
                      p: 1.3,
                      borderRadius: 5,
                    }}
                  >
                    {`${user.name}(${user.empCode})`}
                    <IconButton
                      sx={{ p: 0.4, color: "crimson" }}
                      onClick={() => handleRemoveDefaultMeetingPermission(user)}
                    >
                      <CloseIcon />
                    </IconButton>
                  </Box>
                );
              })}
              {userListToRender.length - 5 > 0 && (
                <Button
                  size="large"
                  variant="outlined"
                  onClick={() => {
                    setOpen(true);
                  }}
                >
                  {`+${userListToRender.length - 5} More`}
                </Button>
              )}
            </Box>
          </Box>
        </AccordionDetails>
      </Accordion>
      {/* </Grid> */}
      {/* modal start  */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <ModalHeader>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              style={{ marginLeft: "15px" }}
            >
              Auto Default Meeting Enabled User List
            </Typography>
            <CustomInputField
              sx={{
                width: 300,
                margin: "0px !important",
              }}
              id="outlined-basic"
              label="Search User"
              name="searchUser"
              variant="outlined"
              size="small"
              inputProps={{ maxLength: 25 }}
              value={searchUser}
              onChange={(e) => setSearchUser(e.target.value)}
            />
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </ModalHeader>
          <ModalBody>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 2,
                my: 1,
                maxHeight: 300,
                overflow: "auto",
              }}
            >
              {userListToRender.map((user) => {
                if (
                  `${user.name}(${user.empCode})`
                    .toLocaleLowerCase()
                    .includes(searchUser.toLocaleLowerCase())
                ) {
                  return (
                    <Box
                      // key={item.id}
                      key={user.id}
                      sx={{
                        backgroundColor: "#E0DCD6",
                        p: 1.3,
                        borderRadius: 5,
                      }}
                    >
                      {`${user.name}(${user.empCode})`}
                      <IconButton
                        sx={{ p: 0.4, color: "crimson" }}
                        onClick={() =>
                          handleRemoveDefaultMeetingPermission(user)
                        }
                      >
                        <CloseIcon />
                      </IconButton>
                    </Box>
                  );
                }
                return null;
              })}
            </Box>
          </ModalBody>
        </Box>
      </Modal>
      {/* modal end */}
    </div>
  );
};

export default DefaultMeetingConfiguration;
